import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ThreePaySuccess from "@/pages/ThreePaySuccess";
import FreeGuide from "@/pages/FreeGuide";
import FieldManual from "@/pages/FieldManual";
import ForgotPassword from "@/pages/ForgotPassword";
import SetPassword from "@/pages/SetPassword";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Library from "@/pages/Library";
import CoursePlayer from "@/pages/CoursePlayer";
import Admin from "@/pages/Admin";
import Author from "@/pages/Author";
import Bundles from "@/pages/Bundles";
import BundleDetail from "@/pages/BundleDetail";
import About from "@/pages/About";
import Newsletter from "@/pages/Newsletter";
import Speak from "@/pages/Speak";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Certificate from "@/pages/Certificate";
import Preview from "@/pages/Preview";
import PreviewCourse from "@/pages/PreviewCourse";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: Process Emergent Google OAuth callback BEFORE the rest of routing.
  // Detect session_id during render (NOT in useEffect) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/books" element={<Catalog type="book" title="The Library" subtitle="Slow, deliberate leadership books — selected for executives and senior operators." />} />
      <Route path="/courses" element={<Catalog type="course" title="The Studio" subtitle="Multi-module courses with downloadable companion frameworks and decision journals." />} />
      <Route path="/p/:id" element={<ProductDetail />} />
      <Route path="/author/:slug" element={<Author />} />
      <Route path="/bundles" element={<Bundles />} />
      <Route path="/bundles/:slug" element={<BundleDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/newsletter" element={<Newsletter />} />
      <Route path="/speak" element={<Speak />} />
      <Route path="/field-notes" element={<Blog />} />
      <Route path="/field-notes/:slug" element={<BlogPost />} />
      <Route path="/preview" element={<Preview />} />
      <Route path="/preview/course" element={<PreviewCourse />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/3pay/success" element={<ThreePaySuccess />} />
      <Route path="/free-guide" element={<FreeGuide />} />
      <Route path="/field-manual" element={<FieldManual />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
      <Route path="/learn/:id" element={<ProtectedRoute><CoursePlayer /></ProtectedRoute>} />
      <Route path="/certificate/:id" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
            <Toaster richColors position="top-right" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
